<button
  id="btnClose"
  type="button"
  class="btn-close close"
  aria-label="Close"
  (click)="bsModalRef.hide()"
>
  <span aria-hidden="true" class="visually-hidden">&times;</span>
</button>
<div class="row">
  <div id="image-section" class="col-12 col-md-4">
    <img src="{{ img }}" alt="{{ altText }}" />
  </div>
  <div
    *appLet="shouldUseMobileStyling$ | async as shouldUseMobileStyling"
    id="content-section"
    class="col"
    [ngClass]="{ 'mb-3': shouldUseMobileStyling }"
  >
    <div class="row">
      <div class="col">
        <p class="fs-1 lh-sm">{{ headerText }}</p>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <p class="fs-4">{{ subText }}</p>
      </div>
    </div>
    <ng-container *ngIf="modalMode === ModalModeEnum.UPGRADE; else standard">
      <div class="row">
        <div class="col text-end">
          <button
            class="btn btn-link"
            (click)="onPrimaryClick()"
            data-qa="modal-cancel-button"
          >
            {{ btnCancelText }}
          </button>
          <button
            class="btn btn-primary"
            (click)="onCancelClick()"
            data-qa="modal-continue-button"
          >
            {{ btnPrimaryText }}
          </button>
        </div>
      </div>
    </ng-container>
    <ng-template #standard>
      <div class="row">
        <div class="col text-end">
          <button
            class="btn btn-link"
            (click)="onCancelClick()"
            data-qa="modal-cancel-button"
          >
            {{ btnCancelText }}
          </button>
          <button
            class="btn btn-primary"
            (click)="onPrimaryClick()"
            data-qa="modal-continue-button"
          >
            {{ btnPrimaryText }}
          </button>
        </div>
      </div>
    </ng-template>
  </div>
</div>
